<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6">
            <div class="card mt-5">
                <div class="card-body">
                    <div class="error-image">
                        <img alt="Something unexpected happened" class="error-image" src="assets/images/something-unexpected.svg" />
                    </div>
                    <div class="heading-md text-center mb-4">{{ errorHeading }}</div>
                    <div class="caption-lg text-center mb-3" [innerHTML]="errorBody"></div>
                    <div class="caption text-center mb-5">
                        Please try again shortly. If this problem persists, contact us at&nbsp;<a href="tel:6177741555">617-774-1555</a>&nbsp;or email us directly at&nbsp;<a href="mailto:trp@dewarinsurance.com">trp&#64;dewarinsurance.com</a>.
                    </div>
                    <div class="text-center"><a href="#" class="btn btn-link" (click)="navigateHome()">Return to home page</a></div>
                </div>
            </div>
        </div>
    </div>
</div>
